/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from '../../../assets/styles/pages/Shops';
import Header from '../../../components/Header';
import FooterMenuMain from '../../../components/FooterMenuMain';
import SearchShops from '../../../components/SearchShops';

import { RootState } from '../../../store';
import { actionListdShops } from '../../../store/reduces/ReducerListShops';

import { ReactComponent as IconStar } from '../../../assets/images/svg/shops/icon_star.svg';

import imgFavoriteSelected from '../../../assets/images/coracao_selected.png';
import imgFavorite from '../../../assets/images/coracao.png';

import { useLoadingContext } from '../../../providers/use-loading';
import { useSelectedStateCityContext } from '../../../providers/use-selected-state-city';
import { useSignInContext } from '../../../providers/use-signin';
import { ItypeReturnApi } from '../../../helpers/utils/TypeReturnApi';
import { api } from '../../../services';
import ModalConfirmFooter from '../../../components/Modal/ConfirmFooter';
import { getStorege } from '../../../helpers/db_storage';

const styleModal = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  p: 4,
  outline: 'none',
};

const Shops: React.FC = () => {
  const classeStyle = useStyles();
  const navegate = useNavigate();
  const { idCategoria, search, tpInterno }: any = useParams();
  const selectedStateCityContext = useSelectedStateCityContext();
  const id_category = idCategoria ? window.atob(idCategoria) : '';
  const des_search = search ? window.atob(search) : '';
  const tp_interno = tpInterno ? window.atob(tpInterno) : '';
  const { reducerListdShops } = useSelector((state: RootState) => state);
  const loadingContext = useLoadingContext();
  const dispatch = useDispatch();
  const { data } = useSignInContext();

  const [listShops, setListShops] = useState<any>([]);
  const [phoneAdm, setPhoneAdm] = useState<any>();
  const [openModalSaq, setOpenModalSaq] = useState(false);
  const [msgSaq, setMsgSaq] = useState<string>('');
  const [openModalNotice, setOpenModalNotice] = useState(false);
  const [msgnModalNotice, setMsgModalNotice] = useState({
    title: 'Atenção',
    messagem: '',
  });
  const [openModalConfirmMajority, setOpenModalConfirmMajority] =
    useState(false);
  const [dataModalConfirmMajority, setDataModalConfirmMajority] = useState({
    title: 'Atenção',
    message:
      'Este estabelecimento contém produtos para maiores de 18 anos. Você confirma que é maior de idade?',
    idShop: '',
  });

  const handleToPage = (url: string) => {
    return navegate(url);
  };

  const sendMsgWhatsApp = (msg: string) => {
    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_API_WHATSAPP}/send?phone=55${phoneAdm[0].nrDDD}${phoneAdm[0].nrTelefone}&text=${msg}`;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
  };

  const handleFavoriteShop = async (
    id_shop: string,
    index: number,
    is_favorite: string,
  ) => {
    try {
      if (!data.user?.idUsuario) {
        setMsgModalNotice({
          title: 'Atenção',
          messagem:
            'É necessário fazer login para favoritar um estabelecimento. Deseja efetuar login agora?',
        });
        setOpenModalNotice(true);
        return;
      }

      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.getPhoneAdm(
        {
          nr_operacao: is_favorite == '1' ? 66 : 67,
          idRestaurante: id_shop,
          idUsuario: data.user?.idUsuario,
        },
      );

      if (result.data.retorno != 'OK') {
        toast.error(result.data.mensagem);
      }
      const newShop = { ...listShops[index], flgFavorito: is_favorite };
      const updatedListShops = [...listShops];
      updatedListShops[index] = newShop;

      setListShops(updatedListShops);
    } catch (error) {
      toast.error('Ocorreu um erro ao favoritar o estabelecimento');
    }
  };

  const getPhoneAdministration = async () => {
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.getPhoneAdm(
        {
          nr_operacao: 17,
          dsCidade: selectedStateCityContext.data.dsCidade,
          idUsuario: data.user?.idUsuario,
        },
      );

      setPhoneAdm(result.data);
    } catch (error) {
      toast.error(
        'Ocorreu um erro ao bucsar número do telefone do administrador',
      );
    }
  };

  const handleOpenShop = (id_shop: any, flgMajority: any) => {
    if (flgMajority == 1) {
      setDataModalConfirmMajority({
        title: 'Atenção!',
        message:
          'Este estabelecimento contém produtos para maiores de 18 anos. Você confirma que é maior de idade?',
        idShop: id_shop,
      });
      setOpenModalConfirmMajority(true);
      return;
    }

    handleToPage(
      `/shop/detail/list/product/subcategorie/${window.btoa(id_shop)}`,
    );
  };

  useEffect(() => {
    if (selectedStateCityContext.data.dsCidade) {
      getPhoneAdministration();
    }
  }, [selectedStateCityContext.data.dsCidade]);

  useEffect(() => {
    const dataStorage = JSON.parse(
      localStorage.getItem('@mais/delivery/dataStateCity') as string,
    );
    const dataUserStorage = getStorege('@mais/delivery/user');

    if (dataStorage?.dsCidade && (id_category || tp_interno)) {
      dispatch(
        actionListdShops.searchListdShops({
          nr_operacao: 20,
          idMarketplace: dataStorage.idMarketplace,
          idCategoria: id_category,
          tpInterno: tp_interno,
          dsBusca: des_search,
          nrLatitude: dataStorage.lat !== '' ? dataStorage.lat : 0,
          nrLongitude: dataStorage.lng !== '' ? dataStorage.lng : 0,
          dsCidade: dataStorage.dsCidade,
          idUsuario: dataUserStorage?.idUsuario
            ? dataUserStorage?.idUsuario
            : '0',
        }),
      );
    }
  }, [id_category, tp_interno]);

  useEffect(() => {
    if (!reducerListdShops.httprequest?.loading) {
      loadingContext.createloading(false);
    }
    if (
      reducerListdShops.httprequest?.loading &&
      !loadingContext.data.noLoading
    ) {
      loadingContext.createloading(true);
    }
    if (reducerListdShops.httprequest?.error) {
      loadingContext.createloading(false);
      toast.error('Ocorreu um erro ao buscar os estabelecimentos');
    }
  }, [reducerListdShops.httprequest]);

  useEffect(() => {
    if (
      reducerListdShops.data.length &&
      !reducerListdShops.httprequest?.loading
    ) {
      const open_shop: any[] = [];
      const close_shop: any[] = [];
      for (let index = 0; index < reducerListdShops.data.length; index += 1) {
        const element: any = reducerListdShops.data[index];

        if (element.flgAberto > 0) {
          open_shop.push(element);
        } else {
          close_shop.push(element);
        }
      }

      setListShops([...open_shop, ...close_shop]);
      return;
    }
    setListShops([]);
  }, [reducerListdShops.data]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="Shops" />
      <CssBaseline />
      <SearchShops children={{ id_category, page: 'shops' }} />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        marginBottom="100px"
      >
        {listShops.length == 0 && !reducerListdShops.httprequest?.loading && (
          <h3 className={classeStyle.titleNotFoundShop}>
            Nenhum estabelecimento foi encontrado!
          </h3>
        )}
        {listShops.length > 0 &&
          !reducerListdShops.httprequest?.loading &&
          listShops.map((shop: any, index: number) => (
            <Grid
              key={shop.idRestaurante}
              className={classeStyle.gridShop}
              container
              item
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid
                item
                xs={10}
                onClick={() =>
                  handleOpenShop(shop.idRestaurante, shop.flgMaiorIdade)
                }
              >
                <Grid
                  container
                  item
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  width="100%"
                >
                  <Grid item xs={3} sm={2} container justifyContent="center">
                    <img
                      src={`${process.env.REACT_APP_API_IMG}${shop.dsImagem}`}
                      alt="banner"
                      className={classeStyle.bannerShop}
                    />
                    {shop.flgAberto == 1 ? (
                      <p className={classeStyle.textTagLive}>Aberto</p>
                    ) : (
                      <p
                        style={{ backgroundColor: '#a51713' }}
                        className={classeStyle.textTagLive}
                      >
                        Fechado
                      </p>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={9}
                    sm={10}
                    paddingLeft={1}
                    display="grid"
                    alignItems="flex-end"
                  >
                    <h3 className={classeStyle.titleShop}>{shop.dsNome}</h3>
                    <Grid item xs={12} container>
                      <p className={classeStyle.textShop}>
                        {shop.dsCategoria.length > 35
                          ? `${shop.dsCategoria.substring(0, 35)}...`
                          : shop.dsCategoria}
                      </p>
                      {shop.dsCupom && (
                        <Grid container marginTop="3px">
                          <p className={classeStyle.textShopCoupom}>
                            {shop.dsCupom}
                          </p>
                        </Grid>
                      )}
                    </Grid>
                    <Grid
                      container
                      item
                      justifyContent="flex-start"
                      alignItems="center"
                      textAlign="center"
                      className={classeStyle.gridAboutMain}
                      marginTop="3px"
                    >
                      {shop.dsTempo && (
                        <Grid className={classeStyle.gridAbout}>
                          <p className={classeStyle.textAbout}>
                            {shop.dsTempo}
                          </p>
                        </Grid>
                      )}
                      {shop.vlEntrega != -1 && (
                        <Grid className={classeStyle.gridAbout}>
                          {shop.vlEntrega.split(' ')[0] == 'Grátis' ? (
                            <p className={classeStyle.textShopCoupom}>
                              {shop.vlEntrega}
                            </p>
                          ) : (
                            <p className={classeStyle.textAbout}>
                              {`${shop.vlEntrega.split('/')[0]}`}
                            </p>
                          )}
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container item justifyContent="flex-end" xs={2} sm={1}>
                {shop.vlMedia && (
                  <Grid className={classeStyle.gridStart}>
                    <IconStar className={classeStyle.iconStart} />
                    <p className={classeStyle.textStart}>
                      {shop.vlMedia.replace('.', ',')}
                    </p>
                  </Grid>
                )}
                <Grid className={classeStyle.gridFavorite}>
                  {shop?.flgFavorito == '1' ? (
                    <img
                      alt="favorite"
                      src={imgFavoriteSelected}
                      className={classeStyle.iconFavorite}
                      onClick={() =>
                        handleFavoriteShop(shop.idRestaurante, index, '0')
                      }
                    />
                  ) : (
                    <img
                      alt="favorite"
                      src={imgFavorite}
                      className={classeStyle.iconFavorite}
                      onClick={() =>
                        handleFavoriteShop(shop.idRestaurante, index, '1')
                      }
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          ))}

        <Button
          onClick={() => setOpenModalSaq(true)}
          className={classeStyle.btnSaq}
        >
          <p className={classeStyle.btnTextSaq}>
            Dúvidas, sugestões ou reclamações?
          </p>
        </Button>
      </Grid>
      <FooterMenuMain children="Shop" />
      <Modal
        open={openModalSaq}
        onClose={() => setOpenModalSaq(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <>
            <Grid
              container
              item
              textAlign="center"
              justifyContent="center"
              xs={12}
              className={classeStyle.content}
            >
              <h3 className={classeStyle.title}>Fale conosco</h3>
            </Grid>
            <Grid
              container
              item
              xs={12}
              justifyContent="center"
              style={{ backgroundColor: '#f9f9f9' }}
              boxShadow="24"
              borderRadius="0 0 25px 25px"
            >
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h6"
                className={classeStyle.titleModal}
                style={{
                  fontWeight: '500',
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '0.9rem',
                }}
              >
                Deixe um comentário
              </Typography>
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className={classeStyle.textModal}
              >
                <input
                  type="text"
                  className={classeStyle.inputText}
                  placeholder="Digite seu comentário"
                  value={msgSaq}
                  name="dsNome"
                  onChange={(e) => setMsgSaq(e.target.value)}
                />
              </Typography>
              <Button
                className={classeStyle.btnModal}
                onClick={() => sendMsgWhatsApp(msgSaq)}
                variant="contained"
              >
                Confirmar
              </Button>
            </Grid>
          </>
        </Box>
      </Modal>

      <ModalConfirmFooter
        isOpen={openModalNotice}
        title={msgnModalNotice.title}
        message={msgnModalNotice.messagem}
        btnNamePrimary="Confirmar"
        btnNameSecondary="Fechar"
        btnCancel=""
        handleFn={async () => handleToPage('/sign/in')}
        handleFn2={async () => setOpenModalNotice(false)}
        onClose={() => setOpenModalNotice(false)}
        heightModal="490px"
      />

      <ModalConfirmFooter
        isOpen={openModalConfirmMajority}
        title={dataModalConfirmMajority.title}
        message={dataModalConfirmMajority.message}
        btnNamePrimary="Sim, tenho 18+"
        btnNameSecondary="Não, voltar"
        btnCancel=""
        handleFn={async () =>
          handleOpenShop(dataModalConfirmMajority.idShop, 0)
        }
        handleFn2={async () => setOpenModalConfirmMajority(false)}
        onClose={() => setOpenModalConfirmMajority(false)}
      />
    </Container>
  );
};

export default Shops;
